import { GrapevineAdminStatisticsDebugApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useGrapevineAdminStatisticsDebugApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new GrapevineAdminStatisticsDebugApi(configuration),
    [configuration]
  );
};
